import TemplatePageBase from '../template-page-base/template-page-base';
import template from './template-consent-page.html';
import logoImage from '../../assets/images/sgx_logo.png';
import { getSingpassAuthToken, getClientId, getSignature, clearStorage } from '../../utils/storage-utils';
import sgxAuthService from '../../services/auth-service';

class TemplateConsentPage extends TemplatePageBase {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateTemplate(this.template.getNode());
    this._logoImageLink = this.querySelector('.sgx-fpds-consent-logo');
    this._logoImageLink.style.backgroundImage = `url(${logoImage})`;
    this.consentBtnElem = this.querySelector('.sgx-fpds-consent-authorize');
    this.rejectBtnElem = this.querySelector('.sgx-fpds-consent-reject');
    this.setEventListeners(true);
  }

  disconnectedCallback() {
    this.setEventListeners(false);
  }

  get template() {
    return template;
  }

  setEventListeners(state) {
    const funcName = state ? 'addEventListener' : 'removeEventListener';
    if (this.consentBtnElem) {
      this.consentBtnElem[funcName]('click', e => {
        e.preventDefault();
        const authToken = getSingpassAuthToken();
        const clientId = getClientId();
        const signature = getSignature();
        clearStorage();
        sgxAuthService.registerSgFinDexConsent({ authToken, clientId, signature });
      });
    }

    if (this.rejectBtnElem) {
      this.rejectBtnElem[funcName]('click', e => {
        e.preventDefault();
        const authToken = getSingpassAuthToken();
        const clientId = getClientId();
        const signature = getSignature();
        clearStorage();
        sgxAuthService.cancelSgFinDexConsent({ authToken, clientId, signature });
      });
    }
  }
}

customElements.define('template-consent-page', TemplateConsentPage);
export default TemplateConsentPage;
